import type { BulkApprovalWorkflowResult } from '@risksmart-app/trpc/src/helpers/run-bulk-approval-workflow';
import type { DeleteAcceptancesMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteAcceptancesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteAcceptances = createMutationHook({
  name: 'deleteAcceptances',
  isChangeRequestGated: true,
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.acceptance.delete.mutationOptions({ onSuccess }),
  mapInput: (ids: string[]) => ({ ids }),
  // The confirmed replay partitions the batch; surface any created or amended
  // change requests on the CR read feeds immediately.
  refreshChangeRequestFeedsWhen: (result: BulkApprovalWorkflowResult) =>
    result.changeRequestIds.length > 0,
  invalidate: (trpc) => [
    // COI-889: router-level key — the hand-listed set missed `acceptanceCount`,
    // the left-nav badge.
    trpc.frontend.acceptance.pathKey(),
    // COI-889: the my-items ribbon counts this entity.
    trpc.frontend.myItems.pathKey(),
  ],
  mapResponse: (): DeleteAcceptancesMutation => ({
    deleteAcceptancesById: {
      __typename: 'GenericMutationOutput',
      affected_rows: 1,
    },
  }),
  graphqlDocument: DeleteAcceptancesDocument,
  graphqlVariables: (ids: string[]) => ({ Ids: ids }),
  evictFields: ['acceptance', 'acceptance_aggregate'],
});
